export default __webpack_public_path__ + "static/ne-7019a67a9ea06975fd7b2b3f93f83f1c.svg";